import type { Messages } from '../types';

export const account = {
  profile: 'Profil',
  back: 'Kembali',
  sectionYourPlan: 'Pelan anda',
  sectionAccount: 'Akaun',
  sectionAbout: 'Mengenai',
  freePlan: 'Pelan percuma',
  notCoveredByPlan: 'Tidak diliputi pelan',
  noSubscription: 'Tiada langganan aktif',
  statusLinkedNotCovered: 'Anak anda sudah berhubung — pilih pelan untuk meliputi mereka',
  statusFreeTrial: 'Percubaan percuma',
  statusGracePeriod: 'Masalah pembayaran — akses diteruskan buat masa ini',
  statusCancelsOn: 'Dibatalkan — akses sehingga {date}, {time}',
  statusCancelled: 'Dibatalkan — akses diteruskan sehingga pelan anda tamat',
  statusLapsed: 'Tamat — naik taraf untuk menyambung',
  statusActive: 'Aktif',
  onFreePlan: 'Anda menggunakan pelan percuma',
  onFreePlanBody:
    'Laporan AI dan pemberian kerja rumah dikunci. Satu langganan merangkumi setiap anak yang anda tambah.',
  upgradeNow: 'Naik taraf sekarang',
  startPlan: 'Mulakan pelan',
  changePlan: 'Tukar pelan',
  manageSubscription: 'Urus langganan',
  yourDetails: 'Butiran anda',
  language: 'Bahasa',
  logOut: 'Log keluar',
  termsOfService: 'Terma perkhidmatan',
  privacyPolicy: 'Dasar privasi',
  appVersion: 'Tupai Parent v{version}',
  deleteAccount: 'Padam akaun',
  errBillingOwnerActive:
    'Akaun anda memiliki langganan keluarga anda. Batalkan langganan itu dahulu, kemudian padam akaun anda.',
  errChildrenLinked:
    'Anda masih mempunyai anak yang dipautkan pada akaun anda. Nyahpaut mereka dahulu, kemudian padam akaun anda.',
  errDeleteFailed: 'Gagal memadam akaun',
  languageSheetBody: 'Menukar apl dengan serta-merta',
  editYourDetails: 'Sunting butiran anda',
  name: 'Nama',
  phoneNumber: 'Nombor telefon',
  phonePlaceholder: 'Tambah nombor telefon anda di sini',
  countryCode: 'Kod negara',
  saving: 'Menyimpan…',
  save: 'Simpan',
  errNameRequired: 'Nama diperlukan',
  errPhoneRequired: 'Nombor telefon diperlukan',
  errContactRequired: 'Masukkan e-mel atau nombor telefon',
  errPhoneInvalid: 'Masukkan nombor telefon yang sah',
  errSaveFailed: 'Gagal menyimpan perubahan',
  phoneVerifyTitle: 'Sahkan nombor baharu anda',
  phoneSendingCode: 'Menghantar kod…',
  phoneSentTo: 'Kami telah menghantar kod 6 digit ke',
  phoneVerifyCta: 'Sahkan nombor',
  phoneCancel: 'Batal',
  phoneTryAgain: 'Cuba lagi',
  errPhoneInUse: 'Nombor ini sudah digunakan oleh akaun lain.',
  errEmailInUse: 'E-mel ini sudah digunakan',
  errPhoneRelogin:
    'Demi keselamatan anda, log keluar dan log masuk semula, kemudian tukar nombor anda.',
  deleteSheetAria: 'Padam akaun anda',
  deleteTitle: 'Padam akaun anda?',
  deleteBody: 'Tindakan ini tidak boleh dibatalkan. Inilah yang akan berlaku:',
  andJoin: 'dan',
  deleteBlockedTitle: 'Anda masih mempunyai anak yang dipautkan',
  deleteBlockedBody: 'Nyahpaut {names} dahulu, kemudian anda boleh padam akaun anda.',
  deleteHistory: 'Laporan dan sejarah kerja rumah anda akan dipadam secara kekal.',
  deleteSubscription:
    'Langganan aktif mesti dibatalkan di gedung apl anda — memadam akaun tidak membatalkannya.',
  deleting: 'Memadam…',
  deleteConfirm: 'Padam akaun saya',
  keepAccount: 'Kekalkan akaun saya',
  trialRibbon: 'Percubaan percuma',
  freeDays: 'PERCUMA {days} hari',
  perMonth: '/ bulan',
  current: 'Semasa',
  close: 'Tutup',
  allSet: 'Semuanya sedia',
  planActive: 'Pelan {tierName} anda kini aktif.',
  planChangeScheduled: 'Perubahan dijadualkan',
  planChangingOn: 'Bertukar ke {tierName} pada {date}',
  planChangingSoon: 'Bertukar ke {tierName} pada akhir tempoh pengebilan ini',
  planChangeScheduledOn:
    'Anda kekal pada pelan semasa sehingga {date}, kemudian beralih ke {tierName}.',
  planChangeScheduledSoon:
    'Anda kekal pada pelan semasa sehingga akhir tempoh pengebilan ini, kemudian beralih ke {tierName}.',
  addYourChild: 'Tambah anak anda',
  stepYourPlan: 'Langkah 1 daripada 2 · Pelan anda',
  stepChoosePlan: 'Langkah 1 daripada 2 · Pilih pelan',
  stepHowTrialWorks: 'Langkah 2 daripada 2 · Cara percubaan anda berfungsi',
  stepConfirm: 'Langkah 2 daripada 2 · Sahkan',
  startMyFreeTrial: 'Mulakan percubaan percuma',
  switchTo: 'Tukar ke {tierName}',
  subscribe: 'Langgan',
  working: 'Memproses…',
  yourPlan: 'Pelan anda',
  seatsUsed: '{used} daripada {total} tempat anak digunakan',
  onePlanEveryChild: 'Satu pelan, semua anak',
  tryFamilySolo: 'Cuba Family Solo Percuma',
  onePlanEveryChildBody: 'Laporan, kerja rumah dan latihan tanpa had.',
  pricingIncluded: '{detail} disertakan.',
  continueLabel: 'Teruskan',
  pickDifferentPlan: 'Pilih pelan lain untuk menukarnya.',
  keepPlan: 'Kekalkan {tierName}',
  alreadyScheduled: 'Perubahan ini telah pun dijadualkan.',
  keepPlanNote: 'Perubahan berjadual anda akan dibatalkan. Tiada apa-apa lagi berubah.',
  pendingChangeOn: 'Dijadualkan bertukar ke {tierName} pada {date}.',
  pendingChangeSoon: 'Dijadualkan bertukar ke {tierName} pada akhir tempoh pengebilan ini.',
  cancelAnytime: 'Batalkan bila-bila masa, atas sebarang sebab.',
  cancelAutoRenew:
    'Batalkan bila-bila masa, atas sebarang sebab. Selepas percubaan percuma, langganan ini diperbaharui secara automatik pada harga yang dipilih di atas.',
  manageBilling: 'Urus pengebilan',
  restorePurchases: 'Pulihkan pembelian',
  trialHeading: '{days} hari percuma.',
  confirmYourPlan: 'Sahkan pelan anda',
  annual: 'Tahunan',
  annualSave: 'Tahunan (jimat {pct}%)',
  monthly: 'Bulanan',
  billingPeriod: 'Tempoh bil',
  thenPriceYearly: '{days} hari pertama percuma, kemudian {price} setahun mulai {date}.',
  thenPriceMonthly: '{days} hari pertama percuma, kemudian {price} sebulan mulai {date}.',
  timelineTodayTitle: 'Hari ini',
  timelineTodayBody: 'Laporan dan kerja rumah dibuka serta-merta.',
  timelineDay: 'Hari {n}',
  timelineReminderBody: 'Tupai akan mengingatkan anda di sini, dalam apl, bahawa ia akan tamat.',
  timelineBilledBody:
    '{native, select, true {Akan dicaj {date}. Batalkan bila-bila masa sebelum itu dalam Google Play.} other {Percubaan anda tamat {date}. Tambah kad dalam Urus pengebilan sebelum itu untuk mengekalkan pelan anda.}}',
  trialNoCardTitle: 'Tiada kad diperlukan hari ini. {price} dari {date}',
  trialNoCardBody: 'Tiada caj melainkan anda menambah kad dalam Urus pengebilan.',
  billedToday: 'Dicaj hari ini',
  proratedNote: 'Dicaj hari ini, ditolak kredit untuk baki masa pelan semasa anda.',
  proratedNoteWeb: 'Dicaj hari ini, ditolak kredit untuk baki masa pelan semasa anda.',
  downgradeNote: 'Bermula pada akhir tempoh pengebilan semasa anda.',
  nothingToday: 'Tiada caj hari ini',
  trialEndsNowNote:
    'Percubaan percuma anda tamat sekarang dan pelan ini bermula serta-merta. Diperbaharui {period}.',
  renewsNote: 'Diperbaharui {period}. Tiada percubaan percuma pada peringkat ini.',
  trialAlreadyUsedNote: 'Diperbaharui {period}. Anda telah menggunakan percubaan percuma anda.',
  renewYearly: 'setiap tahun',
  renewMonthly: 'setiap bulan',
  finishInApp: 'Selesaikan dalam apl',
  finishInAppBody:
    'Langganan dibeli melalui gedung apl, jadi langkah ini hanya berfungsi dalam apl Tupai.',
  errPurchaseFailed: 'Pembelian gagal. Anda tidak dicaj — sila cuba lagi.',
  errPlanChangeNotReflected:
    'Pembayaran anda berjaya, tetapi pelan anda masih dikemas kini. Ia akan dipaparkan sebentar lagi — sila jangan bayar lagi.',
  purchaseLinkedToAnotherAccount:
    'Langganan platform ini dipautkan kepada akaun Tupai yang lain. Log masuk ke akaun yang digunakan untuk melanggan, atau hubungi sokongan. Sila jangan buat pembelian lagi untuk menyelesaikan masalah ini.',
  purchaseStillSyncing:
    'Pembelian anda telah diterima, tetapi pelan anda masih dikemas kini. Sila semak semula sebentar lagi dan jangan buat pembelian lagi.',
  restoreStillSyncing:
    'Langganan platform anda ditemui, tetapi pelan anda masih dikemas kini. Sila cuba pulihkan semula sebentar lagi; anda tidak perlu membuat pembelian lagi.',
  errRestoreFailed: 'Tidak dapat memulihkan pembelian. Semak sambungan anda dan cuba lagi.',
  errNothingToRestore: 'Tiada apa-apa untuk dipulihkan pada akaun ini.',
  cardNeededToSwitch:
    'Tambah kad untuk selesai menukar kepada {plan}. Ia dicaj seperti yang ditunjukkan pada skrin sebelumnya.',
  errAddCard:
    'Pembayaran itu tidak berjaya. Tambah atau kemas kini kad dalam Urus pengebilan, kemudian cuba lagi. Pelan anda tidak berubah.',
  checkoutPending:
    'Pembelian anda selesai, tetapi pelan anda masih disediakan. Sila jangan bayar lagi.',
  storePurchasePending:
    'Pembelian anda sedang menunggu kelulusan atau pembayaran. Pelan anda akan dikemas kini setelah disahkan. Sila jangan buat pembelian lagi.',
  checkAgain: 'Semak semula',
  errLoadPrices: 'Tidak dapat memuatkan harga. Semak sambungan anda.',
  blockedTooManyChildren: 'Anda mempunyai {count} anak yang berhubung. Putuskan satu dahulu.',
  managedElsewhere: 'Pelan anda diuruskan di {store}',
  managedElsewhereBody:
    'Buka portal pengebilan di sana untuk membuat perubahan, atau teruskan di web.',
  billingOwnershipUnknown: 'Platform langganan tidak dapat dikenal pasti',
  billingOwnershipUnknownBody:
    'Kami perlu mengesahkan tempat langganan anda diurus sebelum anda boleh menukar pelan. Sila cuba lagi.',
  billingManagementUnavailable:
    'Pautan pengurusan tidak tersedia untuk langganan ini. Cuba lagi, atau urus melalui platform tempat anda melanggan.',
  errManageBilling: 'Tidak dapat membuka pengurusan bil. Semak sambungan anda dan cuba lagi.',
  seatPickerTitle: 'Pilih siapa yang dikekalkan pada {tierName}',
  seatPickerBody:
    'Pelan ini meliputi {max} anak. Pilih siapa yang dikekalkan — selebihnya akan diputuskan hubungan.',
  seatPickerKeepCount: '{selected} daripada {max} dipilih',
  seatPickerConfirm: 'Sahkan dan tukar pelan',
  seatPickerCancel: 'Batal',
  seatPickerReleaseFailed:
    'Gagal memutuskan hubungan seorang anak. Tiada perubahan dibuat — cuba lagi.',
  seatPickerKeepConfirm: 'Kekalkan anak ini',
  seatPickerUpgradeInstead: 'Naik taraf sahaja',
  overLimitBannerBody:
    '{plan} meliputi {limit} anak, dan {linked} dipautkan. Pilih siapa yang dikekalkan, atau naik taraf untuk mengekalkan semua. Semua anak kekal dengan akses penuh sehingga anda memilih.',
  blockedIgcseTitle: 'Anda mempunyai anak yang mengambil IGCSE',
  blockedIgcseBody:
    'Minta {names} bertukar ke KSSM atau KSSR dalam apl mereka dahulu, kemudian anda boleh beralih ke Standard. Anda juga boleh memutuskan hubungan mereka di skrin Anak.',
  syllabusOverTierTitle: 'Sukatan pelajaran anak melebihi pelan anda',
  syllabusOverTierBody:
    'Pelan anda telah berubah di luar apl dan tidak lagi meliputi IGCSE. Minta anak anda bertukar ke KSSM atau KSSR dalam apl mereka, atau naik taraf untuk mengekalkan IGCSE.',
  tierSolo: '1 ibu bapa + 1 anak',
  tierDuo: '1 ibu bapa + 2 anak',
  tierExtended: '1 ibu bapa + sehingga 5 anak',
  pricingStandard: 'KSSR dan KSSM',
  pricingPremium: 'KSSR, KSSM dan IGCSE',
  syllabusQuestion: 'Sukatan pelajaran apakah yang anak anda ikuti?',
  pricingStandardLabel: 'Malaysia sahaja',
  pricingPremiumLabel: 'Malaysia + IGCSE',
  notNow: 'Bukan sekarang',
  seePlans: 'Lihat pelan',
  gateTrialSeatTitle: 'Percubaan meliputi satu anak sahaja',
  gateTrialSeatBody:
    'Percubaan percuma anda meliputi satu anak. Tukar kepada pelan berbayar dahulu, kemudian tambah lebih ramai anak.',
  gateSeatLimitTitle: 'Tiada tempat pelajar berbaki',
  gateSeatLimitBody:
    'Pelan anda tiada tempat pelajar berbaki. Naik taraf untuk menambah seorang lagi anak.',
  gateSeatLimitMaxTierTitle: 'Tiada tempat pelajar berbaki',
  gateSeatLimitMaxTierBody:
    'Pelan anda tiada tempat pelajar berbaki, dan ini sudah pelan terbesar kami. Kami sedang membangunkan pelan untuk keluarga yang lebih besar — semak semula tidak lama lagi.',
  gotIt: 'Baiklah',
  gateSeatsOverCapTitle: 'Anda melebihi had pelan anda',
  gateSeatsOverCapBody:
    'Pelan anda meliputi lebih sedikit anak berbanding yang kini dipautkan. Nyahpaut seorang anak untuk menepati pelan anda, atau naik taraf untuk mengekalkan semua.',
  manageChildren: 'Urus anak',
  gateFeatureTitle: 'Naik taraf untuk menggunakan ini',
  gateFeatureBody: 'Ciri ini memerlukan langganan yang aktif.',
  gateUpgradeTitle: 'Tidak disertakan dalam pelan anda',
  gateUpgradeBody:
    'Sukatan ini memerlukan pelan yang lebih tinggi. Naik taraf untuk memberi babnya dan memuat turun kertasnya.',
  gateQuotaTitle: 'Anda telah mencapai had bulan ini',
  gateQuotaBody:
    'Anda boleh melakukannya lagi bulan depan — atau naik taraf untuk akses tanpa had.',
  gateFallbackTitle: 'Tidak tersedia pada pelan anda',
  gateFallbackBody: 'Naik taraf untuk membukanya.',
  emailInvalid: 'Alamat e-mel tidak sah',
  emailRelogin: 'Sila log keluar dan log masuk semula untuk menukar e-mel anda.',
  emailUpdateFailed: 'Gagal mengemas kini e-mel.',
  awaitingVerificationPrefix: 'Menunggu pengesahan untuk',
  awaitingVerificationSuffix: '. Sila semak peti masuk anda.',
  reauthTitle: 'Sahkan identiti anda',
  reauthBody: 'Demi keselamatan anda, sila masukkan kata laluan anda untuk menukar alamat e-mel.',
  reauthPasswordLabel: 'Kata laluan',
  reauthConfirm: 'Sahkan',
  reauthConfirming: 'Mengesahkan...',
  reauthIncorrect: 'Kata laluan salah. Sila cuba lagi.',
  reauthFailed: 'Pengesahan gagal.',
  storeNames: {
    PLAY_STORE: 'Google Play',
    APP_STORE: 'App Store',
    MAC_APP_STORE: 'App Store',
    STRIPE: 'web',
    RC_BILLING: 'web',
    PADDLE: 'web',
    AMAZON: 'Amazon',
    GALAXY: 'Galaxy Store',
    PROMOTIONAL: 'pemberian promosi',
    EXTERNAL: 'platform lain',
    TEST_STORE: 'kedai ujian',
    UNKNOWN_STORE: 'platform lain',
  },
} as const satisfies Messages['account'];
